import { Token } from '@yetiswap/sdk'
import INFTCollections from './INFTCollections'

export interface INFTStakeList {
  contractAddress: string
  collection: INFTCollections
  earnToken: Token
  maxSupply: number
  rewardMultiplier?: number
  finishAt?: Date
}

export enum StakeState {
  STAKED,
  STAKE_PENDING,
  UNSTAKED
}
